const custom_stripe_billing_ui = require('./custom-stripe-billing-ui__base.json');
const data_catalog = require('./data-catalog__base.json');
const data_residency_ui = require('./data-residency-ui__base.json');
const data_retention_ui = require('./data-retention-ui__7-day-default.json');
const data_retention_ui1 = require('./data-retention-ui__aws.json');
const data_retention_ui2 = require('./data-retention-ui__azure.json');
const data_retention_ui3 = require('./data-retention-ui__base.json');
const data_retention_ui4 = require('./data-retention-ui__data-retention-ent.json');
const data_retention_ui5 = require('./data-retention-ui__data-retention-starter-growth.json');
const data_retention_ui6 = require('./data-retention-ui__failed-download-credentials.json');
const in_app_email_support = require('./in-app-email-support__base.json');
const tracking_plans = require('./tracking-plans__base.json');

module.exports = {
  "project_64c0dc71ffddf09e95b831f3": {
    "base": {...custom_stripe_billing_ui}
  },
  "project_651469d044134222fe8dcbf7": {
    "base": {...data_catalog}
  },
  "project_638523fc63f559803763cec0": {
    "base": {...data_residency_ui}
  },
  "project_63062f550e89ed6a0dfbe143": {
    "7-day-default": {...data_retention_ui},
    "aws": {...data_retention_ui1},
    "azure": {...data_retention_ui2},
    "base": {...data_retention_ui3},
    "data-retention-ent": {...data_retention_ui4},
    "data-retention-starter-growth": {...data_retention_ui5},
    "failed-download-credentials": {...data_retention_ui6}
  },
  "project_630fc9c45c0e7caa5f6fde15": {
    "base": {...in_app_email_support}
  },
  "project_635944cdd3f2b3c9c3a38b2b": {
    "base": {...tracking_plans}
  }
}